const init = () => {

    var $pageDimmer = $('.c-page-dimmer');
    $pageDimmer.on('click touchstart', onPageDimmerClick);

    var keys = {
        ESC: 27
    };

    $(document.body).on('keydown', function(e) {
        if (e.which === keys.ESC) {
            onPageDimmerClick();
        }
    })

    function onPageDimmerClick(e) {
        PubSub.publish('page-dimmer:clicked');
        // stops click firing if event type was touchstart
        return false;
    }

}

export default init;